export const contactData = [
  {
    id: 1,
    si_no: "",
    select: "",
    customer_name: "Darlee Robertson",
    customer_image: "assets/img/profiles/avatar-19.jpg",
    customer_no: "Facility Manager",
    phone: "1234567890",
    email: "robertson@example.com",
    location: "Germany",
    tag: "Collab",
    rating: "4.2",
    owner: "Hendry",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "1",
  },
  {
    id: 2,
    si_no: "",
    select: "",
    customer_name: "Sharon Roy",
    customer_image: "assets/img/profiles/avatar-20.jpg",
    customer_no: "Installer",
    phone: "+1 989757485",
    email: "sharon@example.com",
    location: "USA",
    tag: "Promotion",
    rating: "5.0",
    owner: "Guillory",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Inactive",
    Action: "",
    key: "2",
  },
  {
    id: 3,
    si_no: "",
    select: "",
    customer_name: "Vaughan",
    customer_image: "assets/img/profiles/avatar-21.jpg",
    customer_no: "Senior  Manager",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    location: "Canada",
    tag: "Collab",
    rating: "3.5",
    owner: "Jami",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "3",
  },
  {
    id: 4,
    si_no: "",
    select: "",
    customer_name: "Jessica",
    customer_image: "assets/img/profiles/avatar-23.jpg",
    customer_no: "Test Engineer",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    location: "India",
    tag: "Rated",
    rating: "4.5",
    owner: "Theresa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "4",
  },
  {
    id: 5,
    si_no: "",
    select: "",
    customer_name: "Carol Thomas",
    customer_image: "assets/img/profiles/avatar-16.jpg",
    customer_no: "UI /UX Designer",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    location: "China",
    tag: "Collab",
    rating: "4.7",
    owner: "Espinosa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "5",
  },
  {
    id: 6,
    si_no: "",
    select: "",
    customer_name: "Dawn Mercha",
    customer_image: "assets/img/profiles/avatar-22.jpg",
    customer_no: "Technician",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    location: "Japan",
    tag: "Rated",
    rating: "5.0",
    owner: "Japan",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "6",
  },
  {
    id: 7,
    si_no: "",
    select: "",
    customer_name: "Rachel Hampton",
    customer_image: "assets/img/profiles/avatar-24.jpg",
    customer_no: "Software Developer",
    phone: "+1 215544845",
    email: "rachel@example.com",
    location: "Indonesia",
    tag: "Promotion",
    rating: "3.1",
    owner: "Newell",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "7",
  },
  {
    id: 8,
    si_no: "",
    select: "",
    customer_name: "Jonelle Curtiss",
    customer_image: "assets/img/profiles/avatar-25.jpg",
    customer_no: "Supervisor",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    location: "Cuba",
    tag: "Rated",
    rating: "5.0",
    owner: "Janet",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "8",
  },
  {
    id: 9,
    si_no: "",
    select: "",
    customer_name: "Jonathan",
    customer_image: "assets/img/profiles/avatar-26.jpg",
    customer_no: "Team Lead Dev",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    location: "Isreal",
    tag: "Collab",
    rating: "2.7",
    owner: "Craig",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "9",
  },
  {
    id: 10,
    si_no: "",
    select: "",
    customer_name: "Brook",
    customer_image: "assets/img/profiles/avatar-01.jpg",
    customer_no: "Team Lead Dev ",
    phone: "+1 278907145",
    email: "brook@example.com",
    location: "Colombia",
    tag: "Promotion",
    rating: "3.0",
    owner: "Daniel",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "10",
  },
  {
    id: 11,
    si_no: "",
    select: "",
    customer_name: "Eric Adams",
    customer_image: "assets/img/profiles/avatar-06.jpg",
    customer_no: "HR Manager",
    phone: "+1 19023-78104",
    email: "ericadams@example.com",
    location: "France",
    tag: "Rated",
    rating: "3.0",
    owner: "Daniel",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "11",
  },
  {
    id: 12,
    si_no: "",
    select: "",
    customer_name: "Richard Cooper",
    customer_image: "assets/img/profiles/avatar-05.jpg",
    customer_no: "Devops Engineer",
    phone: "+1 18902-63904",
    email: "richard@example.com",
    location: "Belgium",
    tag: "Rated",
    rating: "3.0",
    owner: "Daniel",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "12",
  },
];
